// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-wg-activities-distribution {
  height: 100% !important;
}
app-wg-activities-distribution fuse-widget .fuse-widget-front.header {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
app-wg-activities-distribution fuse-widget .fuse-widget-front.content {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top: none;
}
app-wg-activities-distribution fuse-widget .example-additional-selection {
  opacity: 0.75;
  font-size: 0.75em;
}
app-wg-activities-distribution fuse-widget .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/main/dashboard/home/widget/wg-activities-distribution/wg-activities-distribution.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;AACQ;EACI,6BAAA;EACA,4BAAA;AACZ;AAEQ;EACI,0BAAA;EACA,yBAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,aAAA;EACA,iBAAA;AADZ;AAKQ;EACI,wBAAA;AAHZ","sourcesContent":["app-wg-activities-distribution {\n    height: 100% !important;\n    fuse-widget {\n        .fuse-widget-front.header {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        .fuse-widget-front.content {\n            border-top-right-radius: 0;\n            border-top-left-radius: 0;\n            border-top: none;\n        }\n\n        .example-additional-selection {\n            opacity: 0.75;\n            font-size: 0.75em;\n        }\n        \n        //hiding the form field subscript to get rid of extra spaces at the bottom\n        .mat-mdc-form-field-subscript-wrapper {\n            display: none !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
